// this is an autogenerated file from App/Account/Content/Settings/Content/TreatmentPayments/Content/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_TreatmentPayments_Content($location_id: uuid!) {
  treatments_settings(where: { location_id: { _eq: $location_id } }) {
    id
    location_id
    data
  }
}

`